import React, { useContext, useEffect, useRef, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
//import { parseRawData } from '../../parsers';
import { UserContext } from 'contexts/ConfigContext';
import { getConfig } from 'utils/helperMethods';
import _ from 'lodash';
import { salesAttributeDataParser } from 'parser/salesAttributionDataParser';
import { priceCurveTrendsChart } from 'gqlQueries/priceCurve';
import { getChart2Chart, getOpportunityTrendsChart } from 'gqlQueries/opportunityIdentificationQueries';
import { salesTrendChartParser } from 'parser/opportunityIdentificationParser/trendsChartParser';
import { chart2DataParser } from 'parser/opportunityIdentificationParser/chart2Parser';

const errorMessage: string = 'Something went wrong!';

function useFetchChart2Data() {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<null | string>(null);
    const [data, setData] = useState<any | null>(null);

    const { appConfig } = useContext(UserContext);
    const opportunityIdentificationConfig = getConfig('opportunityIdentification', appConfig);

    const [fetchChart2Data, { data: chart2Data, loading: chart2DataLoading, error: chart2DataError }] = useLazyQuery(
        getChart2Chart,
        {
            onCompleted: onFetchComplete,
            onError: onFetchError,
        },
    );

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            const { getCompetitorsElasticityBreakdown } = payload;
            //const featureGroup = payload;
            //if data present parse it
            if (getCompetitorsElasticityBreakdown && 'attributeData' in getCompetitorsElasticityBreakdown) {
                const parsedData = chart2DataParser(
                    getCompetitorsElasticityBreakdown?.attributeData,
                    opportunityIdentificationConfig,
                );
                setData({ chartData: parsedData });
                return;
            }

            setData(null);
        } catch (error) {
            console.error(errorMessage, error);
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        //sending empty data to error to avoid null data being sent
        setData(null);
        setLoading(false);
        setError(error);
    }

    return {
        loading,
        error,
        data,
        setLoading,
        fetchChart2Data: (variables: any) => {
            setData(null);
            setLoading(true);
            setError(null);
            //onFetchComplete(dummyData);
            fetchChart2Data(variables);
        },
    };
}

export { useFetchChart2Data };
